import styled, { css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IRltdContentsSectionProps {
  $bgColor?: string;
  $textColor?: string;
}

export const RltdContentsSection = styled.div<IRltdContentsSectionProps>`
  ${({ $bgColor, $textColor }) =>
    $bgColor &&
    css`
      background: ${$bgColor};

      .main-title,
      .title,
      .desc,
      .basic-btn {
        color: ${$textColor};
      }
    `}
  padding: 32px 0;

  &.bg-type-white {
    background: #fff;
  }

  &.bg-type-black {
    background: #000;

    .main-title,
    .title {
      color: #fff;
    }

    .desc {
      color: #999;
    }

    .basic-btn {
      color: #fff;
      border-color: #555;
    }
  }

  .basic-btn {
    background: transparent;
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('32 0')};
  }

  @media ${({ theme }) => theme.media.pc} {
    padding: 65px 0;

    .section-title {
      width: var(--pc-width);
      margin: 0 auto;
    }

    .content-list {
      width: var(--pc-width);
      margin: 0 auto;

      &.flex {
        ${mixin.flex({ justify: 'flex-start' })};
        gap: 0 18px;

        .rltd-cntnt-item {
          width: 251px;
        }
      }
    }
  }
`;
